module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-3-1-8fd3c763ab224047d21d8d81ce45bb91.jpg";